import { render, staticRenderFns } from "./FreightTableClientsTable.vue?vue&type=template&id=22038dca&scoped=true"
import script from "./FreightTableClientsTable.vue?vue&type=script&lang=js"
export * from "./FreightTableClientsTable.vue?vue&type=script&lang=js"
import style0 from "./FreightTableClientsTable.vue?vue&type=style&index=0&id=22038dca&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22038dca",
  null
  
)

export default component.exports